const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search, cerdasTypeId, courseId, gradeId, educationalLevel }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(
        `/api/bank-soal?cerdasTypeId=${cerdasTypeId ? cerdasTypeId : ''}&course=${courseId ? courseId : ''}&grade=${
          gradeId ? gradeId : ''
        }&educationalLevel=${educationalLevel ? educationalLevel : ''}&search=${search ? search : ''}`
      );
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/bank-soal/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  import({ rootGetters }, { courseId, gradeId, quizId }) {
    return window.axios.post(`/api/bank-soal/${quizId}/import`, { courseId, gradeId });
  }
};

export default { namespaced, state, getters, mutations, actions };
